import styled from 'styled-components';

interface KeypointerCanvasContainerProps {
  scale?: number;
}

export const KeypointerCanvasContainer = styled.div.attrs({
  className: 'KeypointerCanvasContainer',
  id: 'FramesWrapper',
})<KeypointerCanvasContainerProps>(
  ({ scale }) => `
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // width: 100%;
    // height: 100%;
    cursor: pointer;
    transform: scale(${scale});
    transition: transform 0.2s ease-in-out;
  `
);

export const KeypointerCanvasSection = styled.canvas.attrs({
  className: 'KeypointerCanvasSection',
  id: 'KeypointerCanvas',
})`
  width: 100% !important;
  height: 100% !important;
`;
